import { TargetUri, FoodBoxPageSections, TrackingActions } from '../../../../types/tracking'

import SinglesImage from '../../../../sections/assets/singles.webp'
import FamiliesImage from '../../../../sections/assets/families.webp'
import VeggieImage from '../../../../sections/assets/veggie.webp'
import AdventurousImage from '../../../../sections/assets/adventurous.webp'
import BusyImage from '../../../../sections/assets/busy.webp'
import HealthyImage from '../../../../sections/assets/healthy.webp'

export const FOOD_BOX_TYPES = {
  heading: 'Food boxes for every kind of appetite',
  categories: [
    {
      id: 'singles',
      title: 'Food Box for Singles',
      subtitle: 'View our recipes for one',
      image: SinglesImage,
      alt: 'Food box for singles with single portion meals',
      target: TargetUri.MENU,
      ctaText: 'Browse recipes for one',
      sectionName: FoodBoxPageSections.FOOD_BOX_SINGLES,
      action: TrackingActions.CLICK_RECIPE_NAVIGATION,
    },
    {
      id: 'families',
      title: 'Food Box for Families',
      subtitle: 'Check out our family-friendly recipes',
      image: FamiliesImage,
      alt: 'Food box for families with family-friendly meals',
      target: TargetUri.FAMILY,
      ctaText: 'Browse family recipes',
      sectionName: FoodBoxPageSections.FOOD_BOX_FAMILIES,
      action: TrackingActions.CLICK_RECIPE_NAVIGATION,
    },
    {
      id: 'veggie',
      title: 'Food Box for Vegetarians or Vegans',
      subtitle: 'Browse our plant-based recipes',
      image: VeggieImage,
      alt: 'Vegetarian and vegan food box with plant-based meals',
      target: TargetUri.VEGETARIAN,
      ctaText: 'Browse veggie recipes',
      sectionName: FoodBoxPageSections.FOOD_BOX_VEGGIE,
      action: TrackingActions.CLICK_RECIPE_NAVIGATION,
    },
    {
      id: 'busy',
      title: 'Food Box for Busy People',
      subtitle: 'Zoom through our 10 Minute and Prepped in 5 meals',
      image: BusyImage,
      alt: 'Quick meal food box for busy people',
      target: TargetUri.TEN_MINUTE_MEALS,
      ctaText: 'Browse quick recipes',
      sectionName: FoodBoxPageSections.FOOD_BOX_BUSY,
      action: TrackingActions.CLICK_RECIPE_NAVIGATION,
    },
    {
      id: 'adventurous',
      title: 'Food Box for Adventurous Tastes',
      subtitle: 'Enjoy cuisines from around the world',
      image: AdventurousImage,
      alt: 'Food box with international cuisines for adventurous eaters',
      target: TargetUri.MENU,
      ctaText: 'Browse global recipes',
      sectionName: FoodBoxPageSections.FOOD_BOX_ADVENTUROUS,
      action: TrackingActions.CLICK_RECIPE_NAVIGATION,
    },
    {
      id: 'healthy',
      title: 'Food Box for Health Conscious',
      subtitle: 'Choose Calorie Controlled, Protein Hit or Fibre Fix recipes',
      image: HealthyImage,
      alt: 'Healthy food box with calorie controlled meals',
      target: TargetUri.CALORIE_CONTROLLED,
      ctaText: 'Browse healthy recipes',
      sectionName: FoodBoxPageSections.FOOD_BOX_HEALTHY,
      action: TrackingActions.CLICK_RECIPE_NAVIGATION,
    },
  ],
}
